
export const adminMixin = {
	methods: {
		transferbill() {
			// this.$api.purchase.saveTransferBill()
			this.$refs.transfergoodsBox.initList()
			this.$refs.transfergoodsBox.box.alertBox()
		},
		transfergoodsBoxSubmit(e) {
			if (e.data.length) {
				this.loading = true
				e.data.forEach((item) => {
					delete(item._X_ROW_KEY)
				})
				this.$api.purchase.saveTransferBill({
					details: JSON.stringify(e.data)
				}).then(() => {
					this.loading = false
					this.transfergoodsBoxData = []
					this.$message.success('操作成功')
				}, () => {
					this.loading = false
				})
			}
		},
		add() {
			if (this.currentPolicy) {
				// this.queryIntelligencePchs()
				// return	
				this.windowName = '【' + this.currentPolicy.policyName + '】'
				if (this.currentPolicy.policyName.includes('应急')) {

					this.addformShow({
						componentname: 'emergentform',
						currentPolicy: this.currentPolicy
					})
				} else {
					this.addformShow({
						currentPolicy: this.currentPolicy
					})
				}
			} else {
				this.$message.error('请选择方案')
			}
		},
		edit(row) {
			if (row.type == 312) {
				this.editformShow(row, {
					componentname: 'emergentform'
				})
			} else {
				this.editformShow(row)
			}
		},
		suggest(row) {
			//this.$api.purchase.demo(row)				
			import('@/components/forms/purchase/suggest.vue').then((res) => {
				this.formModule = {
					component: res.default,
					show: true,
					extra: {
						purchaseid: row.id
					}
				}
			})
		},
		queryIntelligencePchs() {
			return new Promise((reslove) => {
				this.$api.purchase.queryIntelligencePchs({
					policyId: this.currentPolicy.policyId,
					pchsStoreUid: this.currentPolicy.sourceStoreUids,
					policyName: this.currentPolicy.policyName,
					//createsugest:true
				}).then(() => {
					reslove()
				})
			})

		},
		policyTreeChange(e) {
			this.parentbread = []
			this.parentbread.push({
				name: e.name
			})
			this.parentbread.push({
				name: e.content
			})
			this.currentPolicy = e
			console.log(e)
		},
		reflash() {
			this.$confirm('是否清除【' + this.currentPolicy.name + '】缓存', '提示', {
				type: 'warning',
				closeOnPressEscape: false,
				closeOnClickModal: false,
				showClose: true
			}).then(() => {
				this.$api.purchase.clearPolicyCache({
					policyId: this.currentPolicy.policyId
				}).then(() => {
					this.$refs.policyTree.list()
					//this.$message.success('操作成功')
				})

			}).catch(() => {

			})
		},

		createPolicySuggest() {
			let index = 1
			return new Promise((reslove, reject) => {
				this.$api.purchase.buildIntelPchsAdvise({
					sourceStoreUids: this.currentPolicy.sourceStoreUids,
					policyId: this.currentPolicy.policyId
				}).then((res) => {
					if (res == 1) {
						reslove()
					} else {
						this.customerloading = true
						let handle = setInterval(() => {
							this.loadingtext = '正在生成采购建议，请稍后...' + (index * 2) + 's'
							index++
							this.$api.purchase.getLongTask().then((res) => {
								if (res) {
									clearInterval(handle)
									reslove(res)
								}
								if (index >= 60) {
									clearInterval(handle)
									this.customerloading = false
									reject('生成失败，请重试')
								}
							}, () => {
								clearInterval(handle)
								this.customerloading = false
								reject('生成失败，请重试')

							})
						}, 2000)
					}
				}, () => {
					reject()
				})
			})
		},
		exportSuggest() {
			if (this.currentPolicy) {
				this.loadingtext = '正在生成采购建议，请稍后...'
				this.createPolicySuggest().then(() => {
					this.loadingtext = '正在组装数据...'
					this.queryIntelligencePchs().then(() => {
						this.customerloading = false
						this.$refs.policyTree.loading = true
						this.$api.goods.list({
							mode: 'box',
							index: 4,
							policyId: this.currentPolicy.policyId,
						}).then((res) => {
							if (res.list.length == 0) {
								this.$message.error('暂无商品数据')
							} else {
								this.createExcle(res.list)
							}
							this.$refs.policyTree.loading = false
						})
					}, () => {
						this.$refs.policyTree.loading = false
						this.$message.error('生成失败')
					})
				}, (e) => {
					if (e) {
						this.$message.error(e)
					}
				})
			} else {
				this.$message.error('请选择方案')
			}
		},
		createExcle(sourcedata) {
			// console.log(this.currentPolicy, sourcedata)
			let XLSX = require('xlsx')
			let workbook = XLSX.utils.book_new()
			let initexportdata = this.initexportdata(sourcedata)
			let worksheetsourcedata = XLSX.utils.aoa_to_sheet(this.createexcletabledata(initexportdata))
			if (this.currentPolicy.policyName.includes('备货')) {
				let useabledata = initexportdata.filter((item) => {
					return item.supplierid && item.warehouseid
				})
				let sheet1data = useabledata.filter((item) => {
					return item.underway_quantity == 0 && item.useable_quantity >= 0
				})



				sheet1data = this.goodsfilter(sheet1data)



				sheet1data = this.$Lodash.sortBy(sheet1data, (item) => {
					if (item.recommendlevel == 'S') {
						return 0
					} else if (item.recommendlevel == 'A') {
						return 1
					} else if (item.supplierid.indexOf('1688') !== -1) {
						return 2
					} else if (item.supplierid.indexOf('淘宝') !== -1) {
						return 3
					} else {
						return 999
					}
				})
				sheet1data = this.addsamesuppliergoods(sheet1data)
				let sheet2data = useabledata.filter((item) => {
					return item.supplierid.toString().indexOf('需加工供应商') !== -1 || item.supplierid.toString()
						.indexOf('纳智套装包装组') !== -1
				})
				sheet2data = sheet2data.filter((item) => {
					return item.name.toString().indexOf('BOM') !== -1 || item.name.indexOf('螺丝套装') !== -1 ||
						item.name.toString().indexOf('螺丝螺母套装') !== -1
				})

				let worksheet1 = XLSX.utils.aoa_to_sheet(this.createexcletabledata(sheet1data))
				let worksheet2 = XLSX.utils.aoa_to_sheet(this.createexcletabledata(sheet2data))

				XLSX.utils.book_append_sheet(workbook, worksheet1, "筛选1")
				XLSX.utils.book_append_sheet(workbook, worksheet2, "筛选2")
			}
			XLSX.utils.book_append_sheet(workbook, worksheetsourcedata, "原数据")
			XLSX.writeFile(workbook, this.currentPolicy.name + '.xlsx');
		},
		goodsfilter(sheet1data) {
			let filter = {
				supplierid:['需加工供应商','纳智套装包装组'],
				model:['下架','不卖','停用','不用'],
				name:['BOM','螺丝套装','螺丝螺母套装'],
			}
			sheet1data = sheet1data.filter((item) => {
				let buff = true
				
				for(let i in filter){
					filter[i].forEach((_item)=>{
						if(item[i].toString().indexOf(_item) !== -1){
							buff = false
						}						
					})
				}

				return buff
			})
			
			// sheet1data = sheet1data.filter((item) => {
			// 	return item.supplierid.toString().indexOf('需加工供应商') === -1 && item.supplierid.toString()
			// 		.indexOf('纳智套装包装组') === -1
			// })
			// sheet1data = sheet1data.filter((item) => {
			// 	return item.model.toString().indexOf('下架') === -1 && item.model.toString().indexOf(
			// 		'不卖') === -1
			// })
			// sheet1data = sheet1data.filter((item) => {
			// 	return item.name.toString().indexOf('BOM') === -1 && item.name.indexOf('螺丝套装') === -1 &&
			// 		item.name.toString().indexOf('螺丝螺母套装') === -1
			// })
			
			return sheet1data
		},


		initexportdata(data) {
			let sourcedata = JSON.parse(JSON.stringify(data))
			// sourcedata = sourcedata.filter((item)=>{
			// 	return item.useable_quantity >= 0 && item.useable_quantity <= item.bottom
			// })

			// console.log(sourcedata)
			for (let i = 0; i < sourcedata.length; i++) {
				let suppliertarget = window.systemData.supplier.find((item) => {
					return item.id == sourcedata[i].supplierid
				})
				let warehousetarget = window.systemData.warehouse.find((item) => {
					return item.id == sourcedata[i].warehouseid
				})

				sourcedata[i].policytype = window.systemMethods.getEmunValue('policytype', sourcedata[i].policytype)
				if (suppliertarget) {
					sourcedata[i].supplierid = suppliertarget.name
				} else {
					sourcedata[i].supplierid = null
				}
				if (warehousetarget) {
					sourcedata[i].warehouseid = warehousetarget.name
				} else {
					sourcedata[i].warehouseid = null
				}

			}
			return sourcedata
		},
		addsamesuppliergoods(data) {
			let targetsupplier = this.$Lodash.uniq(this.$Lodash.map(data, 'supplierid'))
			let resdata = []
			for (let i = 0; i < targetsupplier.length; i++) {
				if (resdata.length >= 150) {
					break
				}
				let temparr = data.filter((item) => {
					return item.supplierid == targetsupplier[i]
				})
				resdata = resdata.concat(temparr)
			}
			return resdata
			// console.log(resdata)
		},


		createexcletabledata(data) {
			let tabledata = [
				[
					"商品编码",
					"商品名称",
					"商品型号",
					"推荐等级",
					"需求量",
					"实际库存",
					"仓库编码",
					"仓库",
					"下限",
					"上限",
					"策略类型",
					"建议采购数量",
					"供应商",
					"采购价格",
					"盒规",
					"箱规",
					"到仓天数",
					"本次采购数量",
					"定做天数",
					"备注",
					"在途库存",
					"可用库存",
					"锁定库存",
					"重量(kg)",
					"仓库数量"
				]
			]
			data.forEach((item) => {
				tabledata.push([
					item.code,
					item.name,
					item.model,
					item.recommendlevel,
					item.requirement,
					item.quantity,
					item.warehousecode,
					item.warehouseid,
					item.bottom,
					item.top,
					item.policytype,
					item.suggestnum,
					item.supplierid,
					item.price,
					item.boxgauge,
					item.bingauge,
					item.getday,
					item.purchasenum,
					item.customizedday,
					item.mark,
					item.underway_quantity,
					item.useable_quantity,
					item.lock_quantity,
					item.weight,
					item.warehousenum
				])
			})

			return tabledata
		}
	},
}